/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiMarkDropUnreadResponse {
    'your_unread_drops_count': number;
    'first_unread_drop_serial_no'?: number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "your_unread_drops_count",
            "baseName": "your_unread_drops_count",
            "type": "number",
            "format": ""
        },
        {
            "name": "first_unread_drop_serial_no",
            "baseName": "first_unread_drop_serial_no",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiMarkDropUnreadResponse.attributeTypeMap;
    }

    public constructor() {
    }
}
